/* Kingswood: scroll dots beside the product pictures, like the "shots navigation" on montblanc.com.
   One dot per ROW of pictures in the stacked gallery (the first picture, then each pair below it);
   the row nearest the middle of the window is filled, and a click scrolls that row into view.
   Desktop only - kw-luxe.css hides the element under 990px, where the gallery is a slider.
   Markup: <kw-shot-dots hidden></kw-shot-dots> inside .product__media-wrapper (sections/main-product.liquid). */
class KwShotDots extends HTMLElement {
  connectedCallback() {
    const wrapper = this.closest('.product__media-wrapper');
    this.gallery = wrapper && wrapper.querySelector('.product__media-list');
    if (!this.gallery) return;

    this.list = document.createElement('ul');
    this.list.className = 'kw-shot-dots__list';
    this.appendChild(this.list);

    this.rows = [];
    this.build = this.build.bind(this);
    this.update = this.update.bind(this);

    this.resizeObserver = new ResizeObserver(this.build);
    this.resizeObserver.observe(this.gallery);
    window.addEventListener('scroll', this.update, { passive: true });
    this.build();
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    window.removeEventListener('scroll', this.update);
  }

  /* Group the visible pictures into rows by their top edge. */
  build() {
    const items = Array.from(this.gallery.querySelectorAll('.product__media-item')).filter(
      (item) => item.offsetParent !== null
    );
    const rows = [];
    items.forEach((item) => {
      const top = Math.round(item.getBoundingClientRect().top + window.scrollY);
      const row = rows.find((candidate) => Math.abs(candidate.top - top) < 4);
      if (row) row.items.push(item);
      else rows.push({ top, items: [item] });
    });
    rows.sort((a, b) => a.top - b.top);
    this.rows = rows;

    if (rows.length < 2) {
      this.hidden = true;
      return;
    }
    this.hidden = false;

    if (this.list.children.length !== rows.length) {
      this.list.innerHTML = '';
      rows.forEach((row, index) => {
        const item = document.createElement('li');
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'kw-shot-dots__dot';
        dot.setAttribute('aria-label', `Picture ${index + 1} of ${rows.length}`);
        dot.addEventListener('click', () => {
          this.rows[index].items[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        item.appendChild(dot);
        this.list.appendChild(item);
      });
    }
    this.update();
  }

  /* The row whose middle is nearest the middle of the window is the active one. */
  update() {
    if (this.rows.length < 2) return;
    const middle = window.innerHeight / 2;
    let active = 0;
    let nearest = Infinity;
    this.rows.forEach((row, index) => {
      const rect = row.items[0].getBoundingClientRect();
      const distance = Math.abs((rect.top + rect.bottom) / 2 - middle);
      if (distance < nearest) {
        nearest = distance;
        active = index;
      }
    });
    Array.from(this.list.children).forEach((item, index) => {
      item.firstElementChild.classList.toggle('is-active', index === active);
      item.firstElementChild.setAttribute('aria-current', index === active ? 'true' : 'false');
    });
  }
}

if (!customElements.get('kw-shot-dots')) customElements.define('kw-shot-dots', KwShotDots);
